import { render } from "./ComOhjePohja.vue?vue&type=template&id=32a84974&ts=true"
import script from "./ComOhjePohja.vue?vue&type=script&lang=ts"
export * from "./ComOhjePohja.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__